import BaseService from '@/scripts/services/base/base.service'

export default class DonationService extends BaseService {
    constructor() {
        super('Donation')
    }

    listAllInstitutionsByLoggedAgent() {
        return this.getRequest('ListAllInstitutionsByLoggedAgent')
    }

    listAllPaymentMethodsByLoggedAgent() {
        return this.getRequest('ListAllPaymentMethodsByLoggedAgent')
    }

    listDonationsByLoggedAgent(filters) {
        return this.postRequest('ListDonationsByLoggedAgent', filters)
    }

    countDonationsByLoggedAgentAndFilters(filters) {
        return this.postRequest(
            'CountDonationsByLoggedAgentAndFilters',
            filters
        )
    }

    cancelDonationBillet(donationBilletId) {
        return this.getRequest(
            'CancelDonationBillet',
            { donationBilletId: donationBilletId },
            false
        )
    }

    createDonation(donation, file) {
        let formData = new FormData()
        formData.append('donationGroupViewModel', JSON.stringify(donation))
        if (file) {
            for (let i = 0; i < file.length; i++) {
                formData.append('files', file[i])
            }
        }
        return this.postFileRequest('CreateDonation', formData)
    }

    createDonationWithoutLogin(donation, file) {
        let formData = new FormData()
        formData.append('donationGroupViewModel', JSON.stringify(donation))
        if (file) {
            formData.append('files', file)
        }
        return this.postFileRequest('CreateDonationWithoutLogin', formData, false)
    }

    createPixKey(donation){
        let formData = new FormData()
        formData.append('donationGroupViewModel', JSON.stringify(donation))
        return this.postRequest('createPixKey', formData, false)
    }

    verifyPix(txid){
        //let formData = new FormData()
        //formData.append('txid', JSON.stringify(txid))
        return this.getRequest('verifyPix/'+txid, false)
    }

    findPersonBySimilarDocument(document) {
        return this.getRequest('FindPersonBySimilarDocument', {
            document: document,
        })
    }

    downloadDonationBillet(donationBilletId) {
        return this.getRequestBlob('DownloadDonationBillet', {
            donationBilletId: donationBilletId,
        })
    }

    getDashboardDetails(filters) {
        return this.postRequest('GetDashboardDetails', filters)
    }

    getDashboardFilters(entityId) {
        return this.getRequest('GetDashboardFilters', { entityId })
    }

    listDonationsFromOfLoggedAgent() {
        return this.getRequest('ListDonationsFromOfLoggedAgent')
    }

    listAllInstitutionsByCurrentCouncil() {
        return this.getRequest('ListAllInstitutionsByCurrentCouncil')
    }

    loadDonationsByDonationGroupId(donationGroupId) {
        return this.getRequest('LoadDonationsByDonationGroupId', {
            donationGroupId,
        })
    }
}
